import { NotificationType, PartialToast, ShToastFactory, Toast } from '@stylehaven/components';

export const GenericActionToast = (
    toastFactory: ShToastFactory,
    message: string,
    link?: string,
    linkText?: string
): Toast =>
    toastFactory.create({
        message,
        type: NotificationType.Update,
        icon: 'spinner',
        iconRotate: true,
        autoClose: false,
        closable: true,
        ...(link && { navigationLink: { route: link } }),
        ...(linkText && { linkText })
    });

export const GenericActionSuccessToast = (message: string, link?: string, linkText?: string): PartialToast => ({
    message,
    ...(link && { navigationLink: { route: link } }),
    ...(linkText && { linkText }),
    type: NotificationType.Success,
    icon: 'thumbs-up',
    iconRotate: false,
    autoClose: true,
    closable: true
});

export const GenericActionFailureToast = (message: string, link?: string, linkText?: string): PartialToast => ({
    message,
    ...(link && { navigationLink: { route: link } }),
    ...(linkText && { linkText }),
    type: NotificationType.Error,
    icon: 'delete',
    iconRotate: false,
    autoClose: true,
    closable: true
});

export const GenericWarningToast = (message: string, link?: string, linkText?: string): PartialToast => ({
    message,
    ...(link && { navigationLink: { route: link } }),
    ...(linkText && { linkText }),
    type: NotificationType.Warning,
    icon: 'warning',
    iconRotate: false,
    autoClose: true,
    closable: true
});
